import { joinURL } from 'ufo'

export const useStatamicPost = () => {
    const submit = async <T>(endpoint: string, data: []) => {
        const apiUrl = joinURL(useRuntimeConfig().public.statamicUrl, '/api')

        // first, we need to get a CSRF token
        await $fetch(joinURL(apiUrl, '/csrf-cookie'), {
            credentials: 'include',
        })

        return $fetch<T>(joinURL(apiUrl, endpoint), {
            method: 'POST',
            body: data,
        })
    }

    return {
        submit,
    }
}
